export default __webpack_public_path__ + "media/mock/src/img/logo-b6dfbddfdac4b5b166322b1a80f5e675.svg";